import { useMediaQuery } from '@material-ui/core';

import { useUser } from '@/hooks/useUser';

import { useCustomTheme } from '../../../../../../hooks/useCustomTheme';
import { adjustmentsAmountFieldColumn } from './components/adjustmentsAmountFieldColumn';
import { adjustmentsAndDisbursedAmountMobileFieldColumn } from './components/adjustmentsAndDisbursedAmountMobileFieldColumn';
import { businessNameFieldColumn } from './components/businessNameFieldColumn';
import { disbursedAmountFieldColumn } from './components/disbursedAmountFieldColumn';
import { issueDateAndReferenceMobileFieldColumn } from './components/issueDateAndReferenceMobileFieldColumn';
import { payoutDateFieldColumn } from './components/issueDateFieldColumn';
import { lenderFieldColumn } from './components/lenderFieldColumn';
import { payoutIdFieldColumn } from './components/payoutIdFieldColumn';
import { referenceNumberFieldColumn } from './components/referenceNumberFieldColumn';
import { statusFieldColumn } from './components/statusFieldColumn';
import { toPayoutDetailFieldColumn } from './components/toPayoutDetailFieldColumn';

export function PayoutsDataGridFields() {
  const { breakpoints } = useCustomTheme();
  const { userEntity } = useUser();

  const isMerchantIdFieldAllowed = !(userEntity?.agent && userEntity.channel && userEntity.merchant);

  const isDownMd = useMediaQuery(breakpoints.down('md'));

  const defaultPayoutFields = {
    desktop: [
      payoutIdFieldColumn({ flex: 0.1 }),
      isMerchantIdFieldAllowed ? businessNameFieldColumn({ flex: 0.35 }) : [],
      payoutDateFieldColumn({ flex: 0.25 }),
      lenderFieldColumn({ flex: 0.17 }),
      referenceNumberFieldColumn({ flex: 0.3 }),
      adjustmentsAmountFieldColumn({ flex: isMerchantIdFieldAllowed ? 0.23 : 0.3 }),
      disbursedAmountFieldColumn({ flex: isMerchantIdFieldAllowed ? 0.23 : 0.3 }),
      statusFieldColumn({ flex: 0.2 }),
      toPayoutDetailFieldColumn({ flex: 0.15 }),
    ],
    mobile: [
      issueDateAndReferenceMobileFieldColumn({ flex: 0.43 }),
      adjustmentsAndDisbursedAmountMobileFieldColumn({ flex: 0.25 }),
      statusFieldColumn({ flex: 0.32 }),
    ],
  };

  const DataGridFields = {
    payout: defaultPayoutFields.desktop,
  };

  const MobileDataGridFields = {
    payout: defaultPayoutFields.mobile,
  };

  return isDownMd ? MobileDataGridFields.payout : DataGridFields.payout;
}
